import React, { useRef, useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar-icon.svg';
import moment from 'moment';

const SingleDatePicker = ({ handleTimeCallback, name, id, inputStyle, wrapStyle, cancelCallback, isPicked, register }) => {
  const dateRangeRef = useRef();
  const [start, setStart] = useState(moment(new Date()));
   
  const handleApply = (event, picker) => {
    picker.element.val(
      picker.startDate.format('MM/DD/YYYY')
    );
  };

  const handleCancel = (event, picker) => {
    dateRangeRef.current.ref.value = "";
    dateRangeRef.current.setStartDate(new Date());
    dateRangeRef.current.setEndDate(new Date());
    cancelCallback();
  };

  return (
    <div className={`${wrapStyle} date-range-wrap-general`}>
      <DateRangePicker
        ref={dateRangeRef}
        onApply={(event, picker) => {
          handleApply(event, picker);
          handleTimeCallback(start, name, id)
        }}
        onCallback={startValue => setStart(startValue)}
        initialSettings={{
          autoUpdateInput: false,
          minDate: moment(new Date()),
          singleDatePicker: true,
          startDate: moment(new Date()),
          locale: {
            cancelLabel: 'Clear',
          },
        }}
        onCancel={handleCancel}
      >
        <input 
          type="text" 
          name={name}
          placeholder="15.01.2020"
          className={inputStyle}
        />
      </DateRangePicker>
      <CalendarIcon fill={isPicked() ? "#B6B6B6" : "#233539"} />
    </div>
  )
}

export default SingleDatePicker;